import React, { useState, useEffect } from "react";
import "./tamperHeroSection.css";
import heroSectionTamperProof from "../images/heroSectionTamperproof.svg";
import heroSectionTamperProofMobile from "../images/heroSectionTamperProofMobile.svg";
import { isMobile, s3url } from "../utility/constand";

const TamperHeroSection = () => {
  const [isHovered, setIsHovered] = useState(false);

  const backgroundImage = isMobile
    ? heroSectionTamperProofMobile
    : heroSectionTamperProof;

  useEffect(() => {
    let timer;
    if (isHovered) {
      timer = setTimeout(() => {
        setIsHovered(false);
      }, 4000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isHovered]);
  const handleRedirectionToDashboard = () => {
    window.open("https://dashboard.tamperproof.co/", "_blank");
  };
  return (
    <>
      <div
        className="tamper-section"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {/* <div className="rotating-mask"> */}
        <div className="tamper-rotating-wrapper">
          <img
            src={`${s3url}/rotatingImage.svg`}
            alt="rotating decoration"
            className="tamper-rotating-image"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{ animationPlayState: isHovered ? "paused" : "running" }}
          />
        </div>

        {/* </div> */}
        <div className="tamper-section-content">
          <h1 className="tamper-section-heading">The Fastest Way</h1>
          <p className="tamper-section-main-text">
            to Prove a PDF wasn't Altered
          </p>
          <p className="tamper-section-text">
            Catch every hidden change: text, numbers, signatures or files
          </p>
          <div className="buttons">
            <button
              className="verify-now-btn"
              onClick={() => handleRedirectionToDashboard()}
            >
              Try For Free
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TamperHeroSection;
